import React, { Component } from 'react'
import { Container } from 'react-bootstrap'
import Chemistry from '../../../../images/chemistry_icon.png';
import Zoology from '../../../../images/zoology_icon.png';
import Physics from '../../../../images/physics_icon.png';
import Maths from '../../../../images/maths_icon.png';
import Botany from '../../../../images/botany_icon.png';
import All from '../../../../images/all_icon.png';
import './_readytofoundationtests.scss'
import moment from 'moment';
import { isMobile } from "react-device-detect";
import * as Cookies from "es-cookie";
import * as compose from 'lodash.flowright';
import { withRouter } from "react-router-dom";

// Subject id -> icon and colour key (matches .rft-subject--<key> in the scss).
const SUBJECT_META = {
    0: { icon: All, key: "all" },
    1: { icon: Botany, key: "botany" },
    2: { icon: Physics, key: "physics" },
    3: { icon: Chemistry, key: "chemistry" },
    4: { icon: Maths, key: "maths" },
    5: { icon: Zoology, key: "zoology" },
}

const CLASS_OPTIONS = ["All", "Class XI", "Class XII"]
const CLASS_IDS = { "Class XI": 1, "Class XII": 2 }

class ReadytoFoundationExamsSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedSubjectVal: 0,
            selectedClass: "All"
        }
        localStorage.setItem("resumeExam", false);
        localStorage.setItem("uid", 0);
        if (JSON.parse(localStorage.getItem("isStudentUserValid")) != "") {
            this.isStudentUserValid = JSON.parse(localStorage.getItem("isStudentUserValid"));
        }
    }

    componentDidMount = () => {
        localStorage.setItem("resumeExam", false);
    }

    handleSelect = (subid) => {
        this.setState({ selectedSubjectVal: subid });
    }

    handleClassSelect = (selectedClass) => {
        this.setState({ selectedClass });
    }

    startExam = (data) => {

        let examname = "";
        if (data.short_name != "") {
            examname = data.exam_name + " (" + data.short_name + ")";
        }
        else {
            examname = data.exam_name;
        }

        localStorage.setItem("sessionid", "0");
        localStorage.setItem("type", "Schedule Exam");
        localStorage.setItem("stype", "schedule_exam");
        localStorage.setItem("exam_paper_id", data.id);
        localStorage.setItem("etype", "schedule");
        localStorage.setItem("examname", examname);
        localStorage.setItem("resumeExam", false);
        localStorage.setItem("examtype_pattern", "free_foundation_exam");


        if (isMobile == true && Cookies.get("institution_id") == 30) {
            window.location.replace("/student/subject/exam");
        } else {
            window.open("/student/subject/exam", "_blank")
        }

    }

    resumeExam = (data) => {
        let examname = "";
        if (data.short_name != "") {
            examname = data.exam_name + " (" + data.short_name + ")";
        }
        else {
            examname = data.exam_name;
        }

        localStorage.setItem("sessionid", "0");
        localStorage.setItem("type", "Schedule Exam");
        localStorage.setItem("stype", "schedule_exam");
        localStorage.setItem("exam_paper_id", data.id);
        localStorage.setItem("etype", "schedule");
        localStorage.setItem("examname", examname);
        localStorage.setItem("examtype_pattern", "free_foundation_exam");
        localStorage.setItem("resumeExam", true);


        if (isMobile == true && Cookies.get("institution_id") == 30) {
            window.location.replace("/student/subject/exam");
        } else {
            window.open("/student/subject/exam", "_blank")
        }
    }
    handleResultFunction = (id) => {
        this.props.history.push({
            pathname: "/student/subject/exam-result",
            state: {
                sessionid: id,
                examtype: "free_foundation_exam",
            }
        })
    }

    // Same rules as before: expired tests get no action, completed ones show
    // results, started ones resume, open ones start, the rest wait.
    examStatus = (item, now) => {
        if (item.exam_expired == true) {
            return { key: "expired", label: "Expired" }
        }
        if (item.is_completed == true) {
            return { key: "completed", label: "Completed", action: "View Results", onClick: () => this.handleResultFunction(item.exam_session_id) }
        }
        if (item.is_started == true && now > item.start_time) {
            return { key: "progress", label: "In progress", action: "Resume Test", onClick: () => this.resumeExam(item) }
        }
        if (item.exam_started == true) {
            return { key: "live", label: "Live now", action: "Start Now", onClick: () => this.startExam(item) }
        }
        return { key: "upcoming", label: "Upcoming", action: "Start Now", disabled: true }
    }

    renderExamCard = (item, now, subjectNames) => {
        const status = this.examStatus(item, now);
        const subject = SUBJECT_META[item.subject_id];
        const start = moment.unix(item.start_time);

        return (
            <div className={`rft-card rft-card--${status.key}`} key={item.id}>
                <div className="rft-card__date">
                    <span className="rft-card__month">{start.format("MMM")}</span>
                    <span className="rft-card__day">{start.format("DD")}</span>
                </div>

                <div className="rft-card__body">
                    <div className="rft-card__tags">
                        <span className={`rft-status rft-status--${status.key}`}>{status.label}</span>
                        {
                            subject && subjectNames[item.subject_id] ?
                                (<span className={`rft-tag rft-subject--${subject.key}`}>{subjectNames[item.subject_id]}</span>) : null
                        }
                        {
                            item.class_id == 1 || item.class_id == 2 ?
                                (<span className="rft-tag">Class {item.class_id == 1 ? "XI" : "XII"}</span>) : null
                        }
                    </div>

                    <h6 className="rft-card__title">{item.exam_name}</h6>

                    <ul className="rft-card__meta">
                        <li><span>Time</span>{start.format("LT")}</li>
                        <li><span>Duration</span>{item.exam_duration}</li>
                        {
                            item.total_marks ? (<li><span>Marks</span>{item.total_marks}</li>) : null
                        }
                    </ul>
                </div>

                {
                    status.action ?
                        (
                            <button
                                type="button"
                                className={`rft-btn ${status.key == "completed" ? "rft-btn--ghost" : ""}`}
                                onClick={status.onClick}
                                disabled={status.disabled}
                            >
                                {status.action}
                            </button>
                        ) : null
                }
            </div>
        )
    }

    render() {

        let currentTime_currentSec = Math.round((new Date()).getTime() / 1000);

        const foundationExamsData = this.props.getGroupWiseExams[0].paidExams;
        const subjects = this.props.stateData.getSubjectsArr || [];
        const { selectedSubjectVal, selectedClass } = this.state;

        const subjectNames = {};
        subjects.forEach(sub => { subjectNames[sub.id] = sub.subject });

        const classFiltered = selectedClass == "All"
            ? foundationExamsData
            : foundationExamsData.filter((item) => item.class_id == CLASS_IDS[selectedClass]);

        const examsList = selectedSubjectVal == 0
            ? classFiltered
            : classFiltered.filter((item) => item.subject_id == selectedSubjectVal);

        const countFor = (subid) => subid == 0
            ? classFiltered.length
            : classFiltered.filter((item) => item.subject_id == subid).length;

        return (
            <Container className='free_foundation_exams'>
                <div className="rft-toolbar">
                    <div className="rft-subjects" role="tablist" aria-label="Subjects">
                        {
                            subjects.map(sub => {
                                const meta = SUBJECT_META[sub.id] || SUBJECT_META[0];
                                const active = sub.id == selectedSubjectVal;
                                return (
                                    <button
                                        type="button"
                                        role="tab"
                                        aria-selected={active}
                                        key={sub.id}
                                        className={`rft-subject rft-subject--${meta.key} ${active ? "active" : ""}`}
                                        onClick={() => this.handleSelect(sub.id)}
                                    >
                                        <img src={meta.icon} alt="" />
                                        <span className="rft-subject__name">{sub.subject}</span>
                                        <span className="rft-subject__count">{countFor(sub.id)}</span>
                                    </button>
                                )
                            })
                        }
                    </div>

                    <div className="rft-filter-row">
                        <div className="rft-segment" role="radiogroup" aria-label="Class">
                            {
                                CLASS_OPTIONS.map(opt =>
                                    <button
                                        type="button"
                                        role="radio"
                                        aria-checked={selectedClass == opt}
                                        key={opt}
                                        className={selectedClass == opt ? "active" : ""}
                                        onClick={() => this.handleClassSelect(opt)}
                                    >
                                        {opt}
                                    </button>
                                )
                            }
                        </div>
                        <span className="rft-count">
                            {examsList.length} {examsList.length == 1 ? "test" : "tests"}
                        </span>
                    </div>
                </div>

                {
                    examsList.length > 0 ?
                        (
                            <div className="rft-grid">
                                {examsList.map((item) => this.renderExamCard(item, currentTime_currentSec, subjectNames))}
                            </div>
                        )
                        :
                        (
                            <div className="rft-empty">
                                <img src={All} alt="" />
                                <h5>Tests will be available soon</h5>
                                <p>There are no tests for this selection yet. Try another subject or class.</p>
                            </div>
                        )
                }
            </Container>
        )
    }
}

export default withRouter(compose(

)(ReadytoFoundationExamsSection));
